import { useParams } from "react-router-dom";
import { EditorPage } from "@/components/editor/EditorPage";

export function UnifiedEditorPage() {
  const { evalId } = useParams<{ evalId: string }>();
  return <EditorPage key={evalId} mode="fill" />;
}
